import React, { useEffect, useState, useCallback } from "react";
import SalonService from "../../services/SalonService";
import { FaTimes, FaSpinner } from "react-icons/fa";
import ReviewItem from "./ReviewItem";
import "./Reviews.css";

export default function AllReviewsModal({ visible, onClose, salonUuid }) {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const fetchReviews = useCallback(async (p) => {
        setLoading(true);
        try {
            const res = await SalonService.getInAppReviews(salonUuid, p, 10);
            const content = res.data?.content || res.data || [];

            if (p === 0) {
                setReviews(content);
            } else {
                setReviews(prev => [...prev, ...content]);
            }

            setHasMore(content.length === 10);
            setPage(p);
        } catch (e) {
            console.error("Failed to load reviews", e);
        } finally {
            setLoading(false);
        }
    }, [salonUuid]);

    useEffect(() => {
        if (visible) {
            fetchReviews(0);
        }
    }, [visible, fetchReviews]);

    if (!visible) return null;

    return (
        <div className="premium-modal-overlay">
            <div className="premium-reviews-modal">
                <div className="modal-header-premium">
                    <div className="header-titles">
                        <h3>Customer Reviews</h3>
                        <span className="subtitle">App Community</span>
                    </div>
                    <button className="close-btn-circle" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="modal-body-premium">
                    {reviews.length === 0 && !loading ? (
                        <div className="empty-reviews-state">
                            <p>No reviews found yet.</p>
                        </div>
                    ) : (
                        <div className="reviews-scroll-list">
                            {reviews.map((item, idx) => (
                                <ReviewItem key={item.id || idx} review={item} />
                            ))}

                            {hasMore && (
                                <button
                                    className="load-more-reviews"
                                    onClick={() => fetchReviews(page + 1)}
                                    disabled={loading}
                                >
                                    {loading ? <FaSpinner className="icon-spin" /> : "Load More Reviews"}
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
